/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2483
 */

var r = require(/* 996 */"./996")
module.exports = function (e) {
  var /* [auto-meaningful-name] */this$__data__ = this.__data__
  var n = r(this$__data__, e)
  return n < 0 ? undefined : this$__data__[n][1]
}
